import BaseResource from './index'
import { dateStringToDatePretty } from '../util/date'

export default class ExperienceResource extends BaseResource {
    static endpoint = '/experience'

    get dateSpanPretty() {
        if(!this.attributes.start_year && !this.attributes.end_year) {
            return ''
        }

        let attr = this.attributes
        let dateBits = []

        if(attr.start_year) {
            let startDate = new Date()
            startDate.setYear(attr.start_year)

            if(attr.start_month) {
                startDate.setMonth(attr.start_month)
            }

            dateBits.push(startDate)
        }

        if(attr.end_year) {
            let endDate = new Date()
            endDate.setYear(attr.end_year)

            if(attr.end_month) {
                endDate.setMonth(attr.end_month)
            }

            dateBits.push(endDate)
        } else {
            dateBits.push('current')
        }

        return dateBits.map((dateInstanceOrString) => {
            return ('string' === typeof dateInstanceOrString) ? dateInstanceOrString : dateStringToDatePretty(dateInstanceOrString, 'MMM yyyy')
        }).join(' to ')
    }
}
